import { Link, useNavigate } from 'react-router-dom'
import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context'
import { UrlPath } from "utility/routes";
import CustomerSupportPromo from 'components/CustomerSupportPromo';
import { Seo } from 'components/Seo';

const Frontpage = () => {
  const navigate = useNavigate();
  const auth = useAuth();
  useEffect(() => {
    if (auth.isAuthenticated) {
      navigate(UrlPath.MyAccount.Home)
    }
  })
  if (auth.isLoading || auth.isAuthenticated) {
    return <></>;
  }

  return (
    <>
      <Seo description='Endre din bedrifts opplysninger hos 1881' />
      <div className="card">
        <div className="card-body">
          <h1 className="h3 mb-4">Endre din bedrifts opplysninger hos 1881</h1>
          <p className="mb-4">
            <img src="front-ill.png" width="1400" height="1117" alt="Min bedrift" className="front-ill"></img>
          </p>
          <p className="lead">
            Her kan du gratis endre og legge til navn, adresser, telefonnummer, lenker,
            bransjer og åpningstider for din bedrift.
          </p>
          <p className="lead">
            I tillegg kan du kjøpe og redigere ekstra lenker, visning av logo og beskrivelse av bedriftens tjenester som tekst og punktliste.
          </p>
          <p className="mb-0">
            <Link
              type="button"
              to=""
              className="btn btn-primary text-white"
              onClick={() => void auth.signinRedirect()}
            >
              Logg inn
            </Link>
          </p>
        </div>
      </div>
      <CustomerSupportPromo showExtraInfo={false} />
    </>
  );
};

export default Frontpage;
